import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Poll/config';
import cn from 'classnames';
import s from './Poll.scss';
const PollViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "poll",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
PollViewer.displayName = 'PollViewer';
export default PollViewer;

//# sourceMappingURL=Poll.js.map